module.exports = __webpack_public_path__ + "img/an2.fc71a243.png";